<script>
    import Lightbox from 'svelte-lightbox/src/Lightbox.svelte';
    import { links } from 'svelte-routing';

    export let isVideo = false;
    export let bg_img = "";
    export let to = "";
    export let source = "";
    export let caption = "";
</script>

<style>
    a {
        text-decoration: none;
    }

    .info-img, .video-wrap {
        max-width: 400px;
        max-height: 260px;
        width: 70vw;
        height: 45vw;
        margin-bottom: var(--spacingMedium);
        background-size: cover !important;
        background-position: 50% 50% !important;
        border-radius: 10px;
    }

    .thumbnail {
        border-radius: 10px;
        width: 100%;
    }

    .info-wrap {
        max-width: 400px;
        width: 70vw;
        margin: 0 var(--spacingLarge) var(--spacingLarge);
        cursor: pointer;
    }

    .video-wrap :global(.clickable) {
        /* The global pseudo selector is because this class comes from the Lightbox component */
        cursor: pointer;
    }

    video {
        max-width: 100%;
        max-height: 80vh;
        margin-bottom: 20px;
    }

    @media screen and (max-width: 967px) {
        .info-img, .video-wrap {
            max-width: 300px;
            max-height: 195px;
        }

        .info-wrap {
            max-width: 300px;
        }
    }

    @media screen and (max-width: 500px) {
        .info-wrap, .video-wrap, .info-img {
            width: auto;
        }
    }

</style>

{#if isVideo}
    <div class="info-wrap">
            <!--<VideoPlayer borderRadius="10px" {poster} {source} />-->
            <div class="video-wrap" style="background: url('{bg_img}')">
                <Lightbox thumbnail description={caption}>
                    <img class="thumbnail" slot="thumbnail" src='/img/play_button.svg' alt="play button">
                    <video controls slot="image"><source src={source} /></video>
                </Lightbox>
            </div>
        <div class="info-text">
            <slot />
        </div>
    </div>
{:else}
    <a href={to} on:click use:links>
        <div class="info-wrap">
            <div class="info-img" style="background: url('{bg_img}') center no-repeat"></div>
            <div class="info-text">
                <slot />
            </div>
        </div>
    </a>
{/if}